export const SET_FOIV_BIG_SUB_THEMES_FETCHING = 'SET_FOIV_BIG_SUB_THEMES_FETCHING';
export const SET_FOIV_BIG_SUB_THEMES_ERROR = 'SET_FOIV_BIG_SUB_THEMES_ERROR';
export const SET_FOIV_BIG_SUB_THEMES = 'SET_FOIV_BIG_SUB_THEMES';
export const CLEAN_FOIV_BIG_SUB_THEMES = 'CLEAN_FOIV_BIG_SUB_THEMES';
export const ABORT_FOIV_BIG_SUB_THEMES_REQUEST = 'ABORT_FOIV_BIG_SUB_THEMES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/FOIVBigSubThemes/actions.js